module.exports = __webpack_public_path__ + "img/robot_ad_modal.501dcbf2.png";